import indowWindowStyles from '../../../../shared/styles/infowindow.style';
import { InfowindowContentBuilder } from '../../../../shared/utils/infoWindowContentBuilder';
import { InfowindowBuilder } from '../../../../shared/utils/infowindowBuilder';
import {
  InfoWindowSocioeconomicDemographic,
  SocioeconomicDemographicInfowWindowPayload,
} from '../types';

const infoWindowSocioeconomicDemographicContent = (
  info: SocioeconomicDemographicInfowWindowPayload,
  sectorCode: string
) => {
  const {
    domicile_type,
    total_domiciles,
    dwellers_per_household,
    total_population,
    family_income,
    age_group,
  } = info;

  const noInfoFound =
    !domicile_type &&
    !total_domiciles &&
    !dwellers_per_household &&
    !total_population &&
    !family_income &&
    !age_group;

  const header = `<h6 class="header--title" data-cy="IWBuildingName">Setor ${sectorCode}</h6>
  `;

  const body = `
  <div div class="body-container--info">
    <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUnitTotalKey"><strong>População total: </strong></p>
      <p class="body-container--info-value" data-cy="IWUnitTotalValue">${total_population}</p>
    </div>
    <div class="info-container">
      <p class="body-container--info-key" data-cy="IWRealtyTypeKey"><strong>Total de domicílios: </strong></p>
      <p class="body-container--info-value" data-cy="IWRealtyTypeValue">${total_domiciles}</p>
    </div>
    <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUseTypeKey"><strong>Moradores por domicílio: </strong></p>
      <p class="body-container--info-value" data-cy="IWUseTypeValue">${dwellers_per_household}</p>
    </div>
    <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUseTypeKey"><strong>Faixa etária: </strong></p>
      <p class="body-container--info-value" data-cy="IWUseTypeValue">${age_group}</p>
    </div>
    <div class="info-container last">
      <p class="body-container--info-key" data-cy="IWUseTypeKey"><strong>Renda familiar: </strong></p>
      <p class="body-container--info-value" data-cy="IWUseTypeValue">${family_income}</p>
    </div>
  </div>
  `;

  const errorBody = `
    <div div class="body-container--info">
      <div class="body-container--error">
        <p>Opa! Não há dados suficientes para esse setor.</p>.
      </div>
    </div>
  `;

  const footer = `
  <button class="infowindow-button" id="IWButton" data-cy="IWBuildingDetailsButton">Ver detalhes</button>
  `;
  return new InfowindowContentBuilder({
    header,
    body: noInfoFound ? errorBody : body,
    footer: noInfoFound ? '' : footer,
  });
};

const style = `
${indowWindowStyles}\n
.body-container--error {
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  height: 60px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-container {
  padding-bottom: 8px;
}
.body-container--error p {
  text-align: center;
  margin: 0;
}
.body-container--info-value {
  text-align: end;
  margin: 0;
  max-width: 170px;
}

.info-container.last {
  height: 40px;
}
`;

const infoWindowSocioeconomicDemographic = ({
  payload,
  sectorCode,
  marker,
  map,
  actions,
}: InfoWindowSocioeconomicDemographic) => {
  return new InfowindowBuilder({
    content: [infoWindowSocioeconomicDemographicContent(payload, sectorCode)],
    marker: marker as google.maps.Marker,
    map,
    actions,
    style,
  });
};

export default infoWindowSocioeconomicDemographic;
